import { render } from "./MpesaIntegrations.vue?vue&type=template&id=20bd7184&scoped=true"
import script from "./MpesaIntegrations.vue?vue&type=script&lang=js"
export * from "./MpesaIntegrations.vue?vue&type=script&lang=js"

import "./MpesaIntegrations.vue?vue&type=style&index=0&id=20bd7184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bd7184"]])

export default __exports__